// import React from "react";
// import "./discover_features.css";
// // Import your images (update these paths with your actual image files)
// import onboardingImage from "../../img/des_sec/Seamless Onboarding & Offboarding.svg";
// import dataDriven from "../../img/des_sec/Data-Driven Reports & Dashboards.svg";
// import ensure from "../../img/des_sec/ensure.svg";
// import Lightning from "../../img/des_sec/Lightning-fast document retrieval.svg";
// import Collaborate from "../../img/des_sec/Collaborate Efficiently.svg";
// import goPaper from "../../img/des_sec/Go Paperless & Save Resources.svg";
// import enterprise from "../../img/des_sec/Enterprise-Grade Security.svg";
// import incident from "../../img/des_sec/Incident Management & Reporting.svg";
// import dashboardImage from "../../img/des_sec/discover_features_6.svg";
// import complianceImage from "../../img/des_sec/discover_features_1.svg";
// import documentImage from "../../img/des_sec/discover_features_6.svg";
// import dividerImage from "../../img/des_sec/dotted_line.svg"; // This should be your dotted line image

// const DiscoverFeatures = () => {
//   return (
//     <div className="discoverFeatures-container-df">
//       {/* Background image would be set in CSS */}

//       <div className="discoverFeatures-content-df">
//         {/* Left Column */}
//         <div className="discoverFeatures-column-df left-column-df">
//           <div className="discoverFeatures-item-df image-item-df">
//             <img
//               src={onboardingImage}
//               alt="Onboarding illustration"
//               className="feature-image-df"
//             />
//           </div>
//           <div className="discoverFeatures-item-df text-item-df ptd-5 pbd-5">
//             <h2>Data-Driven Reports & Dashboards</h2>
//             <p>
//               Make informed decisions with customizable, dynamic reports and
//               interactive dashboards.
//             </p>
//           </div>
//           <div className="discoverFeatures-item-df image-item-df">
//             <img
//               src={ensure}
//               alt="Compliance illustration"
//               className="feature-image-df"
//             />
//           </div>
//           <div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4">
//             <h2>Lightning-fast document retrieval</h2>
//             <p>
//               Securely store and retrieve critical workforce documents with our
//               cloud-based document management system.
//             </p>
//           </div>
//           <div className="discoverFeatures-item-df image-item-df">
//             <img
//               src={Collaborate}
//               alt="Compliance illustration"
//               className="feature-image-df"
//             />
//           </div>
//           <div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4">
//             <h2>Go Paperless & Save Resources</h2>
//             <p>
//               Reduce costs and environmental impact with a fully digital
//               onboarding and workforce management system.
//             </p>
//           </div>
//           <div className="discoverFeatures-item-df image-item-df">
//             <img
//               src={enterprise}
//               alt="Compliance illustration"
//               className="feature-image-df"
//             />
//           </div>
//           <div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4">
//             <h2>Incident Management & Reporting</h2>
//             <p>
//               Track and manage incidents with detailed logging, automated audit
//               trails, and real-time notifications for compliance and risk
//               mitigation.
//             </p>
//           </div>
//         </div>

//         {/* Middle Divider */}
//         <div className="discoverFeatures-divider-df">
//           <img src={dividerImage} alt="Divider" className="divider-image-df" />
//         </div>

//         {/* Right Column */}
//         <div className="discoverFeatures-column-df right-column-df">
//           <div className="discoverFeatures-item-df text-item-df pbd-4">
//             <h2>Seamless Onboarding & Offboarding</h2>
//             <p>
//               Effortlessly manage the entire lifecycle of contract workers with
//               digital onboarding and automated offboarding solutions.
//             </p>
//           </div>
//           <div className="discoverFeatures-item-df image-item-df">
//             <img
//               src={dataDriven}
//               alt="Dashboard illustration"
//               className="feature-image-df"
//             />
//           </div>
//           <div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4">
//             <h2>Ensure 100% Compliance</h2>
//             <p>
//               Stay audit-ready with automated regulatory compliance checks,
//               real-time tracking, and proactive alerts for PF, ESI, and labor
//               law adherence.
//             </p>
//           </div>

//           <div className="discoverFeatures-item-df image-item-df">
//             <img
//               src={Lightning} //lightningImage
//               alt="Document management illustration"
//               className="feature-image-df"
//             />
//           </div>
//           <div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4">
//             <h2>Collaborate Efficiently</h2>
//             <p>
//               Facilitate smooth communication between HR teams, contract
//               workers, and contractor agencies for enhanced operational
//               efficiency.
//             </p>
//           </div>

//           <div className="discoverFeatures-item-df image-item-df">
//             <img
//               src={goPaper}
//               alt="Document management illustration"
//               className="feature-image-df"
//             />
//           </div>
//           <div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4">
//             <h2>Enterprise-Grade Security</h2>
//             <p>
//               Hosted on a SOC 2-compliant Google Cloud platform, ensuring data
//               privacy, encryption, and CERT-IN certified security.
//             </p>
//           </div>

//           <div className="discoverFeatures-item-df image-item-df">
//             <img
//               src={incident}
//               alt="Document management illustration"
//               className="feature-image-df"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Main heading */}
//       <h1 className="main-heading-df">Why struggle, just VYN it!</h1>
//     </div>
//   );
// };

// export default DiscoverFeatures;


import React, { useRef, useEffect, useState } from "react";
import { useSpring, animated } from 'react-spring';
import "./discover_features.css";
import onboardingImage from "../../img/des_sec/Seamless Onboarding & Offboarding.svg";
import dataDriven from "../../img/des_sec/Data-Driven Reports & Dashboards.svg";
import ensure from "../../img/des_sec/ensure.svg";
import Lightning from "../../img/des_sec/Lightning-fast document retrieval.svg";
import Collaborate from "../../img/des_sec/Collaborate Efficiently.svg";
import goPaper from "../../img/des_sec/Go Paperless & Save Resources.svg";
import enterprise from "../../img/des_sec/Enterprise-Grade Security.svg";
import incident from "../../img/des_sec/Incident Management & Reporting.svg";
import dashboardImage from "../../img/des_sec/discover_features_6.svg";
import complianceImage from "../../img/des_sec/discover_features_1.svg";
import documentImage from "../../img/des_sec/discover_features_6.svg";
import dividerImage from "../../img/des_sec/Dots.svg";

const DiscoverFeatures = () => {
  // State for container visibility (for background animation)
  const [containerInView, setContainerInView] = useState(false);
  const containerRef = useRef(null);

  // State and refs for individual items
  const [headingInView, setHeadingInView] = useState(false);
  const headingRef = useRef(null);
  const leftRef1 = useRef(null);
  const leftRef2 = useRef(null);
  const leftRef3 = useRef(null);
  const leftRef4 = useRef(null);
  const leftRef5 = useRef(null);
  const leftRef6 = useRef(null);
  const leftRef7 = useRef(null);
  const leftRef8 = useRef(null);
  const rightRef1 = useRef(null);
  const rightRef2 = useRef(null);
  const rightRef3 = useRef(null);
  const rightRef4 = useRef(null);
  const rightRef5 = useRef(null);
  const rightRef6 = useRef(null);
  const rightRef7 = useRef(null);
  const rightRef8 = useRef(null);
  const dividerRef = useRef(null);
  const leftRefs = [leftRef1, leftRef2, leftRef3, leftRef4, leftRef5, leftRef6, leftRef7, leftRef8];
  const rightRefs = [rightRef1, rightRef2, rightRef3, rightRef4, rightRef5, rightRef6, rightRef7, rightRef8];
  const [leftInView, setLeftInView] = useState(Array(8).fill(false));
  const [rightInView, setRightInView] = useState(Array(8).fill(false));
  const [dividerInView, setDividerInView] = useState(false);
  const [hasDividerAnimated, setHasDividerAnimated] = useState(false);

  // Intersection Observer for container (background animation)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setContainerInView(entry.isIntersecting);
      },
      { threshold: 0.1, rootMargin: '0px 0px' }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Intersection Observer for heading
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setHeadingInView(entry.isIntersecting);
      },
      { threshold: 0.3, rootMargin: '0px 0px' }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) {
        observer.unobserve(headingRef.current);
      }
    };
  }, []);

  // Intersection Observers for left column items
  useEffect(() => {
    const observers = leftRefs.map((ref, index) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setLeftInView(prev => {
            const newState = [...prev];
            newState[index] = entry.isIntersecting;
            return newState;
          });
        },
        { threshold: 0.3, rootMargin: '0px 0px' }
    );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return observer;
    });

    return () => {
      leftRefs.forEach((ref, index) => {
        if (ref.current) {
          observers[index].unobserve(ref.current);
        }
      });
    };
  }, []);

  // Intersection Observers for right column items
  useEffect(() => {
    const observers = rightRefs.map((ref, index) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setRightInView(prev => {
            const newState = [...prev];
            newState[index] = entry.isIntersecting;
            return newState;
          });
        },
        { threshold: 0.3, rootMargin: '0px 0px' }
      );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return observer;
    });

    return () => {
      rightRefs.forEach((ref, index) => {
        if (ref.current) {
          observers[index].unobserve(ref.current);
        }
      });
    };
  }, []);

  // Intersection Observer for divider (one-time animation)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasDividerAnimated) {
          console.log('Divider in view, animating'); // Debug log
          setDividerInView(true);
          setHasDividerAnimated(true);
          observer.disconnect(); // Stop observing after first animation
        }
      },
      { threshold: 0.5, rootMargin: '0px 0px' } // Increased threshold for reliability
    );

    if (dividerRef.current) {
      console.log('Observing divider'); // Debug log
      observer.observe(dividerRef.current);
    } else {
      console.log('Divider ref not found'); // Debug log
    }

    return () => {
      if (dividerRef.current) {
        observer.unobserve(dividerRef.current);
      }
    };
  }, [hasDividerAnimated]);

  // Animation for the main heading
  const headingAnimation = useSpring({
    opacity: headingInView ? 1 : 0,
    transform: headingInView ? 'translateY(0px)' : 'translateY(30px)',
    config: { tension: 180, friction: 35, mass: 1 }
  });

  // Animations for left column items
  const leftAnimation1 = useSpring({
    opacity: leftInView[0] ? 1 : 0,
    transform: leftInView[0] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation2 = useSpring({
    opacity: leftInView[1] ? 1 : 0,
    transform: leftInView[1] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation3 = useSpring({
    opacity: leftInView[2] ? 1 : 0,
    transform: leftInView[2] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation4 = useSpring({
    opacity: leftInView[3] ? 1 : 0,
    transform: leftInView[3] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation5 = useSpring({
    opacity: leftInView[4] ? 1 : 0,
    transform: leftInView[4] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation6 = useSpring({
    opacity: leftInView[5] ? 1 : 0,
    transform: leftInView[5] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation7 = useSpring({
    opacity: leftInView[6] ? 1 : 0,
    transform: leftInView[6] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation8 = useSpring({
    opacity: leftInView[7] ? 1 : 0,
    transform: leftInView[7] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });

  // Animations for right column items
  const rightAnimation1 = useSpring({
    opacity: rightInView[0] ? 1 : 0,
    transform: rightInView[0] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation2 = useSpring({
    opacity: rightInView[1] ? 1 : 0,
    transform: rightInView[1] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation3 = useSpring({
    opacity: rightInView[2] ? 1 : 0,
    transform: rightInView[2] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation4 = useSpring({
    opacity: rightInView[3] ? 1 : 0,
    transform: rightInView[3] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation5 = useSpring({
    opacity: rightInView[4] ? 1 : 0,
    transform: rightInView[4] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation6 = useSpring({
    opacity: rightInView[5] ? 1 : 0,
    transform: rightInView[5] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation7 = useSpring({
    opacity: rightInView[6] ? 1 : 0,
    transform: rightInView[6] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation8 = useSpring({
    opacity: rightInView[7] ? 1 : 0,
    transform: rightInView[7] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });

  // Animation for divider (slide-in, one-time)
  const dividerAnimation = useSpring({
    opacity: dividerInView ? 1 : 0,
    transform: dividerInView ? 'translateY(0px)' : 'translateY(20px)',
    config: { tension: 140, friction: 35, mass: 1 }
  });

  return (
    <div className={`discoverFeatures-container-df ${containerInView ? 'animate-background' : ''}`} ref={containerRef}>
      <div className="discoverFeatures-content-df">
        {/* Left Column */}
        <div className="discoverFeatures-column-df left-column-df">
          <animated.div className="discoverFeatures-item-df image-item-df" style={leftAnimation1} ref={leftRef1}>
            <img src={onboardingImage} alt="Onboarding illustration" className="feature-image-df" />
          </animated.div>
          <animated.div className="discoverFeatures-item-df text-item-df ptd-5 pbd-5" style={leftAnimation2} ref={leftRef2}>
            <h2>Vyn Insights: Conversational Reporting</h2>
            <p>Stop digging through spreadsheets. Vyn Insights turns static reports into a conversation. Just ask a question and get the answers you need to make better decisions instantly. It’s reporting that actually speaks your language.</p>
          </animated.div>
          <animated.div className="discoverFeatures-item-df image-item-df" style={leftAnimation3} ref={leftRef3}>
            <img src={ensure} alt="Compliance illustration" className="feature-image-df" />
          </animated.div>
          <animated.div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4" style={leftAnimation4} ref={leftRef4}>
            <h2>Lightning-fast document retrieval</h2>
            <p>Securely store and retrieve critical workforce documents with our cloud-based document management system.</p>
          </animated.div>
          <animated.div className="discoverFeatures-item-df image-item-df" style={leftAnimation5} ref={leftRef5}>
            <img src={Collaborate} alt="Collaboration illustration" className="feature-image-df" />
          </animated.div>
          <animated.div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4" style={leftAnimation6} ref={leftRef6}>
            <h2>Go Paperless & Save Resources</h2>
            <p>Reduce costs and environmental impact with a fully digital onboarding and workforce management system.</p>
          </animated.div>
          <animated.div className="discoverFeatures-item-df image-item-df" style={leftAnimation7} ref={leftRef7}>
            <img src={enterprise} alt="Security illustration" className="feature-image-df" />
          </animated.div>
          <animated.div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4" style={leftAnimation8} ref={leftRef8}>
            <h2>Incident Management & Reporting</h2>
            <p>Track and manage incidents with detailed logging, automated audit trails, and real-time notifications for compliance and risk mitigation.</p>
          </animated.div>
        </div>

        {/* Middle Divider */}
        {/* <animated.div className="discoverFeatures-divider-df" style={dividerAnimation} ref={dividerRef}> */}
          <img 
            src={dividerImage} 
            alt="Divider" 
            className="divider-image-df" 
            onError={() => console.log('Failed to load divider image')} // Debug log
          />
        {/* </animated.div> */}

        {/* Right Column */}
        <div className="discoverFeatures-column-df right-column-df">
          <animated.div className="discoverFeatures-item-df text-item-df pbd-4" style={rightAnimation1} ref={rightRef1}>
            <h2>Seamless Onboarding & Offboarding</h2>
            <p>Effortlessly manage the entire lifecycle of contract workers with digital onboarding and automated offboarding solutions.</p>
          </animated.div>
          <animated.div className="discoverFeatures-item-df image-item-df" style={rightAnimation2} ref={rightRef2}>
            <img src={dataDriven} alt="Dashboard illustration" className="feature-image-df" />
          </animated.div>
          <animated.div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4" style={rightAnimation3} ref={rightRef3}>
            <h2>Ensure 100% Compliance</h2>
            <p>Stay audit-ready with automated regulatory compliance checks, real-time tracking, and proactive alerts for PF, ESI, and labor law adherence.</p>
          </animated.div>
          <animated.div className="discoverFeatures-item-df image-item-df" style={rightAnimation4} ref={rightRef4}>
            <img src={Lightning} alt="Document management illustration" className="feature-image-df" />
          </animated.div>
          <animated.div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4" style={rightAnimation5} ref={rightRef5}>
            <h2>Vinny: Your Smart Assistant</h2>
            <p>Get the help you need without the wait. Vinny is your smart assistant, ready to help you navigate the platform, answer your questions, and resolve issues in real time. It’s like having a VYN expert by your side around the clock.</p>
          </animated.div>
          <animated.div className="discoverFeatures-item-df image-item-df" style={rightAnimation6} ref={rightRef6}>
            <img src={goPaper} alt="Paperless illustration" className="feature-image-df" />
          </animated.div>
          <animated.div className="discoverFeatures-item-df text-item-df ptd-5 pbd-4" style={rightAnimation7} ref={rightRef7}>
            <h2>Enterprise-Grade Security</h2>
            <p>Hosted on a SOC 2-compliant Google Cloud platform, ensuring data privacy, encryption, and CERT-IN certified security.</p>
          </animated.div>
          <animated.div className="discoverFeatures-item-df image-item-df" style={rightAnimation8} ref={rightRef8}>
            <img src={incident} alt="Incident management illustration" className="feature-image-df" />
          </animated.div>
        </div>
      </div>

      {/* Main heading */}
      <animated.h1 className="main-heading-df" style={headingAnimation} ref={headingRef}>
        Why struggle, just VYN it!
      </animated.h1>
    </div>
  );
};

export default DiscoverFeatures;
